import { Module } from '@nestjs/common';
import { MailModule } from '../mail/mail.module';
import { PrismaModule } from '../prisma/prisma.module';
import { ReportesProveedorController } from './reportes-proveedor.controller';
import { ReportesProveedorService } from './reportes-proveedor.service';

@Module({
  imports: [PrismaModule, MailModule],
  controllers: [ReportesProveedorController],
  providers: [ReportesProveedorService],
  exports: [ReportesProveedorService],
})
export class ReportesProveedorModule {}
